import { Extension } from "@tiptap/core";

/**
 * Keeps `class`, `id` and `data-*` on every node.
 *
 * The notice editor does not need this - its valid_elements allowlist never
 * permitted a class, so stored notices carry none. The factsheet is the
 * opposite: factsheetHtml.js keeps the document's own `<style>` block verbatim
 * and that CSS targets the body's classes, so a dropped class is a dropped
 * layout rule. `valid_elements: "*[*]"` there is a deliberate promise to keep
 * everything.
 *
 * Attribute names have to be declared up front in a schema, so `data-*` is
 * collapsed into one `dataset` attribute that captures and replays whatever
 * the document happens to carry.
 */

const DEFAULT_TYPES = [
  "paragraph",
  "heading",
  "blockquote",
  "codeBlock",
  "bulletList",
  "orderedList",
  "listItem",
  "horizontalRule",
  "image",
  "table",
  "tableRow",
  "tableCell",
  "tableHeader",
  "genericBlock",
  "genericTextBlock",
];

export const PreservedAttributes = Extension.create({
  name: "preservedAttributes",

  addOptions() {
    return { types: DEFAULT_TYPES };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          class: {
            default: null,
            parseHTML: (element) => element.getAttribute("class") || null,
            renderHTML: (attributes) =>
              attributes.class ? { class: attributes.class } : {},
          },
          id: {
            default: null,
            parseHTML: (element) => element.getAttribute("id") || null,
            renderHTML: (attributes) =>
              attributes.id ? { id: attributes.id } : {},
          },
          dataset: {
            default: null,
            parseHTML: (element) => {
              const data = {};
              Array.from(element.attributes || []).forEach((attribute) => {
                if (attribute.name.indexOf("data-") === 0) {
                  data[attribute.name] = attribute.value;
                }
              });
              return Object.keys(data).length ? data : null;
            },
            renderHTML: (attributes) => attributes.dataset || {},
          },
        },
      },
    ];
  },
});

export default PreservedAttributes;
